// Вход аккаунтом гипнозио и возврат на нужную страницу.
//
// Своей регистрации у гипновейва нет: аккаунты живут в одном месте, на
// гипнозио. Отсюда человек уходит на его эндпоинт выдачи тикета и возвращается
// на /sso/callback уже с тикетом в адресе.

export const GIPNOZIO_ORIGIN = (process.env.REACT_APP_GIPNOZIO_ORIGIN || '').replace(/\/$/, '');

const DESTINATION_KEY = 'gw_after_login';

/**
 * Куда вернуть человека после входа.
 *
 * По ссылке из кабинета он приходит сразу на конкретную запись, и просто
 * выкинуть его на главную после входа — значит потерять то, зачем он шёл.
 * Держим в sessionStorage, а не в состоянии React: вход через гипнозио уводит
 * из вкладки целиком, и любое состояние в памяти по дороге теряется.
 */
export function rememberDestination(path) {
  if (typeof sessionStorage === 'undefined') return;
  // Только внутренние адреса: сюда попадает то, что было в адресной строке,
  // и открывать по этому значению чужой сайт мы не должны.
  if (!path || !path.startsWith('/') || path.startsWith('//')) return;
  if (path.startsWith('/auth') || path.startsWith('/sso/')) return;
  try { sessionStorage.setItem(DESTINATION_KEY, path); } catch { /* приватный режим */ }
}

/** Забрать и сразу забыть сохранённый адрес. По умолчанию — главная. */
export function takeDestination() {
  if (typeof sessionStorage === 'undefined') return '/';
  try {
    const path = sessionStorage.getItem(DESTINATION_KEY);
    sessionStorage.removeItem(DESTINATION_KEY);
    return path || '/';
  } catch {
    return '/';
  }
}

/** Адрес, на который уводим за тикетом. Пусто — вход через гипнозио не настроен. */
export function buildSsoUrl() {
  if (!GIPNOZIO_ORIGIN) return '';
  const next = `${window.location.origin}/sso/callback`;
  return `${GIPNOZIO_ORIGIN}/api/sso/authorize?next=${encodeURIComponent(next)}`;
}

/**
 * Живём ли мы внутри семьи gipnozio.ru.
 *
 * От этого зависит, можно ли спросить гипнозио про вход напрямую. Cookie
 * сессии выписана на `.gipnozio.ru`: с поддомена браузер отправит её сам, а с
 * чужого домена — не отправит никогда, сколько ни проси. Поэтому на чужом
 * домене остаётся прежний путь: уход за тикетом и возврат.
 */
export function inGipnozioFamily() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'gipnozio.ru' || host.endsWith('.gipnozio.ru');
}

/**
 * Тихо спросить гипнозио: «этот человек вошёл?» — и если да, забрать тикет.
 *
 * Возвращает строку с тикетом, либо null, если человек не вошёл или спросить
 * не получилось. Ошибку сети от «не вошёл» здесь намеренно не отличаем: и в
 * том, и в другом случае показываем свой экран входа, а не пустоту.
 */
export async function requestTicket() {
  if (!GIPNOZIO_ORIGIN || !inGipnozioFamily()) return null;
  try {
    const res = await fetch(`${GIPNOZIO_ORIGIN}/api/sso/ticket`, {
      method: 'GET',
      credentials: 'include',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data && data.authenticated && data.ticket ? data.ticket : null;
  } catch {
    return null;
  }
}
